import styles from './styles.less';
import { observer } from 'mobx-react';


const LetterNav = (props) => (
    <nav className={ cx(styles.root, props.className) }>
        <ul className={ styles.list }>
            { props.letters.map(letter => (
                <li className={ cx(styles.letter, { [styles.selectedLetter]: props.selectedLetter === letter }) }>
                    <button
                        className={ styles.button }
                        onClick={ () => props.onSelectLetter(letter) }>
                        { letter }
                    </button>
                </li>
            )) }
        </ul>
    </nav>
);

LetterNav.propTypes = {
    letters: React.PropTypes.array.isRequired,
    onSelectLetter: React.PropTypes.func.isRequired,
    selectedLetter: React.PropTypes.string
};


export default observer(LetterNav);



// WEBPACK FOOTER //
// ./src/show-index/components/letter-nav/index.js